export default __webpack_public_path__ + "static/media/contact.b2145059.jpg";